export default __webpack_public_path__ + "static/media/authentication-img.43b59e59.png";